import VueRouter, { RouteConfig } from 'vue-router'
import { BrowserUtil, RouterUtil, WeappUtil } from 'kuaidong-lib'
import { FileTypeEnum } from 'kuaidong-model'
const ProcessEvaluation = () => import('../views/pe-class/ProcessEvaluation.vue')
const PEClassEvaluation = () => import('../views/pe-class/PEClassEvaluation.vue')
const PEClassScheduleList = () => import('../views/pe-class/PEClassScheduleList.vue')
const PEClassEvaluationDetail = () => import('../views/pe-class/PEClassEvaluationDetail.vue')

const DataStatisticsPage = () => import('../views/pe-class/DataStatistics.vue')
const AnalysisReportPage = () => import('../views/pe-class/AnalysisReport.vue')

const BatchCommentPage = () => import('../views/pe-class/BatchComment.vue')
const BatchCheckAttendancePage = () => import('../views/pe-class/BatchCheckAttendance.vue')

const CustomPerformanceType = () => import('../views/pe-class/CustomPerformanceType.vue')

const DataStatisticsClazzDetail = () => import('../views/pe-class/DataStatisticsClazzDetail.vue')

const DataStatisticsStudentDetail = () => import('../views/pe-class/DataStatisticsStudentDetail.vue')

const PEStudentListManagement = () => import('../views/pe-class/PEStudentListManagement.vue')

const PEClazzManagementList = () => import('../views/pe-class/PEClazzManagementList.vue')

const PEBatchDeleteStudents = () => import('../views/pe-class/PEBatchDeleteStudents.vue')

const PEFastImportStudents = () => import('../views/pe-class/PEFastImportStudents.vue')

const PEClassUploadExcel = () => import('../views/pe-class/PEClassUploadExcel.vue')

export const peClassUploadExcelRoute: RouteConfig = {
  path: '/pe-class-upload-excel',
  name: 'pe_class_upload_excel',
  component: PEClassUploadExcel,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '导入名单',
  },
}

export const peFastImportStudentsRoute: RouteConfig = {
  path: '/pe-fast-import-students',
  name: 'pe_fast_import_students',
  component: PEFastImportStudents,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '快速导入',
  },
}

export const peBatchDeleteStudentsRoute: RouteConfig = {
  path: '/pe-batch-delete-students',
  name: 'pe_batch_delete_students',
  component: PEBatchDeleteStudents,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '批量删除学生',
  },
}

export const peClazzManagementListRoute: RouteConfig = {
  path: '/pe-clazz-management-list',
  name: 'pe_clazz_management_list',
  component: PEClazzManagementList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '班级名单详情',
  },
}

export const peStudentListManagementRoute: RouteConfig = {
  path: '/pe-student-list-management',
  name: 'pe_student_list_management',
  component: PEStudentListManagement,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学生名单管理',
  },
}

export const BatchCommentRoute: RouteConfig = {
  path: '/batch-comment',
  name: 'batch_comment',
  component: BatchCommentPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '批量点评',
  },
}

export const BatchCheckAttendanceRoute: RouteConfig = {
  path: '/batch-check-attendance',
  name: 'batch_check_attendance',
  component: BatchCheckAttendancePage,
  props: (route) => ({ ...route.query, ...route.params }),

  meta: {
    title: '批量考勤',
  },
}

export const peClassEvaluationRoute: RouteConfig = {
  path: 'pe-class-evaluation',
  name: 'pe_class_evaluation',
  component: PEClassEvaluation,
  meta: {
    title: '体育课评价',
  },
}

export const peClassScheduleListRoute: RouteConfig = {
  path: '/pe-class-schedule-list',
  name: 'pe_class_schedule_list',
  component: PEClassScheduleList,
  meta: {
    title: '课程表',
  },
}

export const PEClassEvaluationDetailRoute: RouteConfig = {
  path: '/pe-class-evaluation-detail',
  name: 'pe_class_evaluation_detail',
  component: PEClassEvaluationDetail,
  props: (route) => ({ ...route.query, ...route.params, lesson: JSON.parse(route.query.lesson as string) }),

  meta: {
    title: '评价情况',
  },
}
export const dataStatisticsRoute: RouteConfig = {
  path: 'data-statistics',
  name: 'data_statistics',
  component: DataStatisticsPage,
  meta: {
    title: '体育课评价',
  },
}

export const dataStatisticsClazzDetailRouter: RouteConfig = {
  path: '/data-statistics-clazz-detail',
  name: 'data_statistics_clazz_detail',
  component: DataStatisticsClazzDetail,
  props: (route) => ({ ...route.query, ...route.params, semesters: JSON.parse(route.query.semesters as string) }),

  meta: {
    title: '班级详情',
  },
}

export const dataStatisticsStudentDetailRouter: RouteConfig = {
  path: '/data-statistics-student-detail',
  name: 'data_statistics_student_detail',
  component: DataStatisticsStudentDetail,
  props: (route) => ({ ...route.query, ...route.params, semesters: JSON.parse(route.query.semester as string) }),

  meta: {
    title: '学生详情',
  },
}

export const analysisReportRoute: RouteConfig = {
  path: 'analysis-report',
  name: 'analysis_report',
  component: AnalysisReportPage,
  meta: {
    title: '体育课出勤',
  },
}

export const customPerformanceTypeRoute: RouteConfig = {
  path: '/custom-performance-type',
  name: 'custom_performance_type',
  component: CustomPerformanceType,
  meta: {
    title: '自定义点评',
  },
}

export const processEvaluationRoute: RouteConfig = {
  path: '/pe-class',
  name: 'process_evaluation',
  redirect: '/pe-class/pe-class-evaluation',
  component: ProcessEvaluation,
  children: [peClassEvaluationRoute, dataStatisticsRoute, analysisReportRoute],
}

export function redirectToPEStudentUploadMapping(router: VueRouter, url: string, fromWeapp = false) {
  if (BrowserUtil.isWeapp()) {
    WeappUtil.chooseMessageFile(
      FileTypeEnum.Excel,
      RouterUtil.buildUrlFromRoute(peClassUploadExcelRoute, { url }, router),
      fromWeapp
    )
    router.go(-1)
  } else {
    router.replace({
      name: peClassUploadExcelRoute.name,
      query: { url },
    })
  }
}

export default [
  processEvaluationRoute,
  peClassScheduleListRoute,
  PEClassEvaluationDetailRoute,
  BatchCommentRoute,
  BatchCheckAttendanceRoute,
  customPerformanceTypeRoute,
  dataStatisticsClazzDetailRouter,
  dataStatisticsStudentDetailRouter,
  peStudentListManagementRoute,
  peClazzManagementListRoute,
  peBatchDeleteStudentsRoute,
  peFastImportStudentsRoute,
  peClassUploadExcelRoute,
]
